// Formatting shared by the store pages. Times are always shown in Prague
// time, said out loud, so a drop at "18:00" means the same thing everywhere.

export function money(minor, currency = "CZK") {
  if (minor == null) return "";
  const v = minor / 100;
  return `${v.toLocaleString("cs-CZ", { maximumFractionDigits: 2 })} ${currency === "CZK" ? "Kč" : currency}`;
}

const TZ = "Europe/Prague";

export function dropDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("en-GB", { timeZone: TZ, day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" });
}

export function shortDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("en-GB", { timeZone: TZ, day: "numeric", month: "short" });
}

export function dateTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleString("en-GB", { timeZone: TZ, day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function timeAgo(iso) {
  if (!iso) return "";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 90) return "just now";
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  return shortDate(iso);
}

// Countdown parts for a target instant (all zero once it's passed).
export function countdownParts(iso, now = Date.now()) {
  const ms = Math.max(0, new Date(iso).getTime() - now);
  const s = Math.floor(ms / 1000);
  return { done: ms === 0, days: Math.floor(s / 86400), hours: Math.floor((s % 86400) / 3600), minutes: Math.floor((s % 3600) / 60), seconds: s % 60 };
}

export const pad = (n) => String(n).padStart(2, "0");

const regionNames = (() => {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" });
  } catch {
    return null;
  }
})();
export const countryName = (code) => regionNames?.of(code) || code;
export const flag = (code) => String.fromCodePoint(...[...code.toUpperCase()].map((c) => 0x1f1a5 + c.charCodeAt(0)));

// S, M, L in wearing order; anything else (EU 38, one size …) after, as is.
const SIZE_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "2XL", "XXXL", "3XL", "4XL"];
export function sortSizes(values) {
  const rank = (v) => {
    const i = SIZE_ORDER.indexOf(String(v).toUpperCase());
    if (i >= 0) return i;
    const n = parseFloat(v);
    return Number.isFinite(n) ? 100 + n : 1000;
  };
  return [...values].sort((a, b) => rank(a) - rank(b) || String(a).localeCompare(String(b)));
}

export function percentOff(price, was) {
  if (!was || was <= price) return 0;
  return Math.round((1 - price / was) * 100);
}

export const firstName = (name) => String(name || "").trim().split(/\s+/)[0] || "";
